import { useSelector } from 'react-redux';

export enum Role {
  Admin = 'Admin',
  Owner = 'Owner',
  Tenant = 'Tenant',
  None = 'None',
}

const permissions = {
  admin: [Role.Admin],
  owner: [Role.Owner],
  tenant: [Role.Tenant],
  'admin.owner': [Role.Admin, Role.Owner],
  'owner.tenant': [Role.Tenant, Role.Owner],
  'admin.tenant': [Role.Admin, Role.Tenant],
  'all.user': [Role.Admin, Role.Owner, Role.Tenant],
};

export type PermissionName = keyof typeof permissions;

export const getUserRole = () =>
  (JSON.parse(localStorage.getItem('user') ?? 'null')?.currentRole || 'None') as Role;

export const usePermissions = () => {
  const userRole: Role = getUserRole();
  const hasPermission = (permissionName: PermissionName) => {
    return permissions[permissionName].includes(Role[userRole]);
  };

  return { hasPermission };
};

export const useRole = () => {
  const userRole: Role = getUserRole();
  const hasRole = () => {
    return Role[userRole];
  };

  return { hasRole };
};
